export default "/images/7f026a798ed60badfcca6a914f16e6e9.avif";